import React, { useContext, useEffect, useState } from "react";
import { Redirect, Route } from "react-router-dom";
import { AdminContext } from "context/AdminContext";
import { logout } from "services/httpService_backup"; // Import the logout function

const PrivateRoute = ({ children, ...rest }) => {
  const { state } = useContext(AdminContext);
  const { adminInfo } = state;

  // State to track whether the session is expired or not
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const authTime = localStorage.getItem("authTime");

 if (authTime) {
  const now = Date.now();
  const timeDiff = now - parseInt(authTime, 10); 
  if (timeDiff > 3600000) {  // 1 hour = 3600000 milliseconds
    setIsExpired(true);
    logout(); 
  }
} else {
  logout(); 
  setIsExpired(true);
}

  }, []); 

  if (isExpired || !adminInfo?.email) {
    return (
      <Redirect
        to={{
          pathname: "/login",
          state: { from: rest.location },
        }}
      />
    );
  }

  // If the session is valid, render the children components
  return <Route {...rest}>{children}</Route>;
};

export default PrivateRoute;
